import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { ElementProviderStripe } from "@/components/checkout/ElemenProviderStripe";
import { useStore } from "@/store/index";
import styles from "../../../styles/booking/booking.module.scss";
import { EButtonUserPage } from "../../../models/common/enums";
import { handleNavigation } from "../../../utils/common/handleNavigation";
import Help from "../../playWithUs/Help";
import ContentSectionLayout from "../booking/ContentSectionLayout";
import PersonalInfoSection from "./PersonalInfoSection";
import Profile from "../../common/account/Profile";
import {
    IAccountButtonProps,
    TAccountButtonType,
    TAccountSectionType,
} from "../../../models/account";

import { handleNavigationAccount } from "../../../utils/common/account";
import YourAccountPage from "./YourAccountPage";
import PaymentsMethodSection from "./PaymentsMethodSection";
import LoginSecurity from "./LoginSecurity";
import PrivacySection from "./PrivacySection";

const UserPageBody = () => {
    const [userPageData, setUserPageData] = useState<TAccountSectionType>({
        title: "Your Account",
        sectionType: EButtonUserPage.YOURACCOUNT,
    });
    const setUserDetail = useStore(state => state.setUserDetail);

    const { title, sectionType } = userPageData;

    const handleUserPageNavigation = (id: TAccountButtonType) =>
        handleNavigation<TAccountButtonType, TAccountSectionType>(
            id,
            userPageData,
            setUserPageData,
            handleNavigationAccount("user")
        );

    const navigationElement: IAccountButtonProps[] = [
        {
            title: "Your Account",
            icon: "icon_bookings.svg",
            onClick: handleUserPageNavigation,
            id: EButtonUserPage.YOURACCOUNT,
            isPrimary: true,
            isSubPrimary: false,
            isActive: false,
            disabled: false,
        },
        {
            title: "Personal Info",
            icon: "personal_info.svg",
            onClick: handleUserPageNavigation,
            id: EButtonUserPage.PERSONALINFOUSERPAGE,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonUserPage.PERSONALINFOUSERPAGE,
            disabled: false,
        },
        {
            title: "Login and Security",
            icon: "lock.svg",
            onClick: handleUserPageNavigation,
            id: EButtonUserPage.LOGINANDSECURITY,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonUserPage.LOGINANDSECURITY,
            disabled: false,
        },
        {
            title: "Payments",
            icon: "payments.svg",
            onClick: handleUserPageNavigation,
            id: EButtonUserPage.PAYMENTSUSERPAGE,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonUserPage.PAYMENTSUSERPAGE,
            disabled: false,
        },
        {
            title: "Privacy",
            icon: "eye.svg",
            onClick: handleUserPageNavigation,
            id: EButtonUserPage.NOTIFICATIONS,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonUserPage.NOTIFICATIONS,
            disabled: false,
        },
    ];

    useEffect(() => {
        // il precedente valore del top era 250 in quanto era presente anche il componente HeadSection
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [sectionType]);

    useEffect(() => {
        setUserDetail();
    }, [setUserDetail, userPageData]);

    return (
        <div className="minWidth100vwFromXL">
            {/* <HeadSection
                className="mb-5"
                content={headData}
                backgroundIsEmpty
            /> */}
            {/* E' stato aggiunto un marginTop di 120px per ottonere lo stesso effetto dello spazio occupato precedentemente dall'HeadSection */}
            <MDBRow
                className={`${styles.container} pb-3`}
                style={{
                    marginTop: "120px",
                }}
            >
                <MDBCol
                    size={12}
                    lg={5}
                    xl={3}
                    className="d-flex justify-content-start align-items-start h-100 p-lg-4"
                >
                    <Profile buttons={navigationElement} />
                </MDBCol>

                <ContentSectionLayout
                    title={title}
                    onClick={handleUserPageNavigation}
                    buttonId={sectionType}
                    buttonBack="View profile"
                >
                    {sectionType === EButtonUserPage.PERSONALINFOUSERPAGE && (
                        <PersonalInfoSection />
                    )}
                    {sectionType === EButtonUserPage.YOURACCOUNT && (
                        <YourAccountPage />
                    )}
                    {sectionType === EButtonUserPage.PAYMENTSUSERPAGE && (
                        <ElementProviderStripe>
                            <PaymentsMethodSection />
                        </ElementProviderStripe>
                    )}
                    {sectionType === EButtonUserPage.LOGINANDSECURITY && (
                        <LoginSecurity />
                    )}
                    {sectionType === EButtonUserPage.NOTIFICATIONS && (
                        <PrivacySection />
                    )}
                </ContentSectionLayout>
            </MDBRow>
            <Help />
        </div>
    );
};

export default UserPageBody;
